import { gql } from '@apollo/client'

export const INITIALIZE_SHEET_EXPORT = gql`
  mutation InitializeSheetExport($sheetId: UUID!, $validationState: String!, $format: String) {
    initializeSheetExport(sheetId: $sheetId, validationState: $validationState, format: $format) {
      id
    }
  }
`
